// src/screens/mypage/MyPageScreen.js
// 28차: 내 활동 섹션에 '포인트 내역' 메뉴 추가
// 32차: statsPrivate 상태 배지 — 탈출 기록 메뉴에 비공개 표시
// 51차: 색 theme.js 단일화 — C 팔레트를 COLORS 참조로 / 초록·빨강·주황 통일
// 72차: "매장 관리" 섹션 신규(isStoreAdmin 전용) — 매장 정보(StoreInfo)와 알림 링크 추가.
//       기존엔 매장관리자에게 계정설정 3개만 보여서 마이탭이 거의 비어있었고,
//       notifBadge(새 예약/리뷰 알림)가 쌓여도 열어볼 메뉴가 없었음.
// 72차: 문의사항 기능 신규 — 매장 관리 섹션에 "문의사항"(매장 문의 응대), 총괄
//       관리자 전용 "앱 관리" 섹션에 "앱 문의"(앱 전체 문의 응대), 일반 회원용
//       "관심 · 모집" 섹션에 "문의 내역"(내가 쓴 문의 + 새 문의 작성) 추가
// 74차: "관심 · 모집" 섹션에 "공지사항" 메뉴 추가 — 공지·소식 하단 탭이 크루 탭으로
//       바뀌면서 여기로 이동(EventsScreen.js에 hidePick:true로 PICK 탭은 안 보이게 진입)
// 74차: 프로필 닉네임 옆 [크루명] 태그 표시 (profile.crewName, onCrewUpdated로 실시간 동기화)
// 74차: "예약 내역"/"내 리뷰" 서브메뉴에 알림 뱃지 추가 — "알림"/"내 모집 관리" 행엔
//       이미 있던 menuAlertBadge 패턴을 재사용. review_reminder/reservation_reminder/
//       store_closed는 getUnreadNotificationCount(탭 전체 뱃지)가 제외하는 타입이라
//       기존엔 어디에도 안 보이던 알림이었음
// 77차: design 폴더 마이페이지 화면 스펙 적용 — 아바타에 골드 그라디언트 링,
// 3-스탯(도전/성공/성공률) 카드를 스펙처럼 플레인 surface 카드로, 로그아웃 버튼을
// 공용 SecondaryButton으로 교체. 스펙의 "Lv.24"/"뱃지" 개념은 이 앱엔 없는 기능이라
// (실제로는 입문/중급/고수/전문가 라벨의 getLevel과 도전/성공/성공률 3-스탯이 그 자리에
// 해당) 새로 만들지 않고 기존 값을 그대로 재사용. "편집" 텍스트링크도 이 화면엔 대응되는
// 별도 진입점이 없어(계정설정 섹션이 이미 그 역할) 추가하지 않음.
// 78차: "예약 내역" 메뉴 설명에 남아있던 "QR" 문구 제거 — 같은 세션에서 QR코드 기능
// 자체를 삭제(ReservationHistoryScreen.js)했는데 이 서브텍스트만 안 고쳐져 있었음.
// 78차: 메뉴 아이콘을 이모지 → design_handoff_unlock 프로젝트에 실제로 있던 SVG 라인
// 아이콘(Icons.js)으로 교체. 매장/총관리자 전용 항목(매장 정보/문의사항 2종/앱 문의)은
// 스펙 12종엔 없어 같은 톤으로 새로 그림(MenuStoreIcon) 또는 의미상 가까운 아이콘 재사용
// (문의 관련은 전부 MenuInquiryIcon).

// 78차 32차: 프로필 사진 변경 버튼(아이콘 전용)에 accessibilityLabel 추가(접근성 라벨 전수 점검)
import React, { useState, useCallback, useRef } from 'react';
import { showAlert } from '../../components/common/AppAlert';
import {
  View, Text, ScrollView, TouchableOpacity, StyleSheet,
  ActivityIndicator, Image,
} from 'react-native';
import { doc, updateDoc, collection, query, where, getDocs } from 'firebase/firestore';
import * as ImagePicker from 'expo-image-picker';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { LinearGradient } from 'expo-linear-gradient';
import { db, storage } from '../../services/firebase';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigation, useFocusEffect } from '@react-navigation/native';
import { getMyPendingPaymentReservations, getMyRecruitReservations, getMyRecruitsWithPending, getUnreadNotificationCount, getMyNotifications, notifyExpiringPoints, notifyUnreviewedReservations } from '../../services/recruitService';
import { getWriteableReservations } from '../../services/reviewService';
import { getMyReservations } from '../../services/reservationService';
import AppHeader, { RoleBadge } from '../../components/common/AppHeader';
import { SecondaryButton, TextButton } from '../../components/common/Buttons';
import { deleteAccount, logout } from '../../services/authService';
import {
  MenuReservationIcon, MenuEscapeIcon, MenuReviewIcon, MenuPointsIcon,
  MenuFavoriteIcon, MenuBellIcon, MenuRecruitIcon, MenuInquiryIcon, MenuNoticeIcon,
  MenuNicknameIcon, MenuPasswordIcon, MenuPrivacyIcon, MenuStoreIcon, CameraIcon,
  EditIcon, IconLabel, RewardIcon, ParticipantAcceptIcon, WarningIcon, HelpCircleIcon,
  PeopleIcon,
  PrivacyLockIcon,
} from '../../components/common/Icons';
import { COLORS, GRADIENTS } from '../../constants/theme';

const C = {
  bg: COLORS.bg, surface: COLORS.surface, card: COLORS.surface2,
  border: COLORS.border, gold: COLORS.gold,
  goldBg: COLORS.goldBg, goldBdr: COLORS.goldBorder,
  text: COLORS.text, textSec: 'rgba(255,255,255,0.6)',
  muted: COLORS.textMuted, success: COLORS.green,
  danger: COLORS.red, warning: COLORS.orange, purple: COLORS.purple,
};
const RADIUS = { sm:8, md:12, lg:16 };

const getLevel = (total = 0) =>
  total >= 50 ? { label:'전문가', color:C.purple }
: total >= 20 ? { label:'고수',   color:C.gold }
: total >= 5  ? { label:'중급',   color:C.success }
:               { label:'입문',   color:C.muted };

export default function MyPageScreen() {
  const navigation = useNavigation();
  const { user, profile, isLoggedIn, refreshProfile } = useAuth();
  const [photoLoading, setPhotoLoading] = useState(false);
  const [deleting, setDeleting] = useState(false); // 78차 38차: 회원 탈퇴 — 마이 탭에서도 바로 접근 가능하게
  const [lockLoading,  setLockLoading]  = useState(false);
  const [pendingPayments,     setPendingPayments]     = useState([]);
  const [recruitReservations, setRecruitReservations] = useState([]);
  const [waitingListAlerts,   setWaitingListAlerts]   = useState(0);
  const [notifCount,          setNotifCount]          = useState(0);
  const [expiringPoints,      setExpiringPoints]      = useState(0);
  const [reservationAlerts,   setReservationAlerts]   = useState(0);
  const [reviewAlerts,        setReviewAlerts]        = useState(0);
  const [inquiryAlerts,       setInquiryAlerts]       = useState(0); // 75차: "앱 문의" 미확인 알림
  const [myInquiryReplyAlerts, setMyInquiryReplyAlerts] = useState(0); // 75차: "문의 내역" 답변 알림
  const [storeInquiryAlerts, setStoreInquiryAlerts]   = useState(0); // 78차 66차: "고객 문의 답변" 미확인 알림
  // 78차 69차: "도전/성공" 통계 — users.escapeStats 필드는 어디서도 실제로 써준 적이 없어
  // (읽기만 하는 코드뿐) 항상 0이었음. EscapeDashboardScreen과 동일하게 예약 기록에서
  // 직접 라이브 계산.
  const [liveEscapeStats, setLiveEscapeStats] = useState(null);

  const adminRole    = profile?.adminRole;
  const isSuperAdmin = adminRole === 'super';
  const isStoreAdmin = adminRole === 'store';
  const isAdmin      = isSuperAdmin || isStoreAdmin;

  // 79차: 탭을 빠르게 오가면 이전 포커스의 여러 badge 조회가 늦게 응답해 최신 숫자를
  // 오래된 것으로 덮어쓸 수 있었음(MyReviewsScreen.js가 74차에 막아둔 것과 동일 위험) —
  // activeRef로 이전 포커스 세션의 setState만 무시. 이 함수는 독립적인 fire-and-forget
  // 조회가 많아 매번 인라인으로 반복하는 대신 guard() 헬퍼로 감쌈.
  const activeRef = useRef(true);
  const guard = (fn) => (v) => { if (activeRef.current) fn(v); };
  const loadAlerts = React.useCallback(() => {
    if (!isLoggedIn || !user?.uid) return;
    getMyPendingPaymentReservations(user.uid).then(guard(setPendingPayments)).catch(() => {});
    getMyRecruitReservations(user.uid).then(guard(setRecruitReservations)).catch(() => {});
    getMyRecruitsWithPending(user.uid).then(guard(list => {
      const total = list.reduce((acc, r) => acc + (r.pendingParticipants?.length || 0), 0);
      setWaitingListAlerts(total);
    })).catch(() => {});
    // 72차: 매장관리자는 운영 알림(new_reservation/new_review)만 세야 "매장 관리 > 알림"
    // 배지 숫자와 NotificationsScreen에 실제로 보이는 목록이 일치한다.
    getUnreadNotificationCount(user.uid, { adminOnly: isStoreAdmin }).then(guard(setNotifCount)).catch(() => {});
    // 74차: "예약 내역"/"내 리뷰" 서브메뉴 뱃지 — point_expiry/review_reminder/store_closed는
    // getUnreadNotificationCount(전체 뱃지)에서 이미 제외되는 타입이라(SYSTEM_NOTIF_TYPES)
    // 별도로 세지 않으면 어디에도 안 보임
    getMyNotifications(user.uid).then(guard(list => {
      const unread = list.filter(n => !n.read);
      setReservationAlerts(unread.filter(n => n.type === 'reservation_reminder' || n.type === 'store_closed').length);
      // 75차: "앱 문의" 미확인 알림 — new_inquiry는 총괄관리자에게만 발송되는 타입
      setInquiryAlerts(unread.filter(n => n.type === 'new_inquiry').length);
      // 75차: "문의 내역" 답변 알림 — inquiry_replied는 문의 작성자(일반 회원/매장관리자)에게 발송
      setMyInquiryReplyAlerts(unread.filter(n => n.type === 'inquiry_replied').length);
      // 78차 66차: "고객 문의 답변" 미확인 알림 — 지금까지 new_store_inquiry 타입 자체가
      // 없어서(onNewInquiry가 targetType:'app'만 처리) 이 뱃지가 항상 0이었음
      setStoreInquiryAlerts(unread.filter(n => n.type === 'new_store_inquiry').length);
    })).catch(() => {});
    // 75차: "내 리뷰" 뱃지 — 안 읽은 review_reminder 알림 개수 대신, MyReviewsScreen.js의
    // "작성 가능" 탭과 동일한 기준(실제 작성 가능한 리뷰 개수)으로 통일. 알림이 안
    // 왔거나 이미 읽었어도 작성 가능한 리뷰가 남아있으면 계속 뱃지에 보여야 함.
    getWriteableReservations(user.uid).then(guard(list => setReviewAlerts(list.length))).catch(() => {});
    // 78차 69차: "도전/성공" 통계 라이브 계산(EscapeDashboardScreen과 동일 기준 — success가
    // true/false로 기록된 예약만 집계 대상, 취소 건 제외)
    getMyReservations(user.uid).then(guard(list => {
      const recorded = list.filter(r => r.cancelled !== true && (r.success === true || r.success === false));
      // 80차 후속: 체험형은 성공/실패 개념이 없어 도전/성공/성공률 집계엔 안 넣고, 별도로
      // "관람 횟수"만 카운트(EscapeDashboardScreen과 동일한 지난 회차 판정 기준).
      const now = new Date();
      const showCount = list.filter(r => r.cancelled !== true && r.bookingFormat === 'show'
        && new Date(`${r.date}T${r.time || '00:00'}`) <= now).length;
      setLiveEscapeStats({ total: recorded.length, success: recorded.filter(r => r.success === true).length, showCount });
    })).catch(() => {});
    // 78차 73차: 근본 원인 발견 — "포인트 소멸 안내"/"리뷰 작성 안내" 알림 자체는 CF로
    // 완성돼 있었지만(notifyExpiringPoints/notifyUnreviewedReservations), 둘 다 클라이언트가
    // 직접 호출해야 하는 onCall 함수인데 어디에서도 호출하는 곳이 없어서(과거엔 이 자리에
    // 이미 서버로 이관돼 아무 것도 안 하는 deprecated 함수 expirePoints()가 대신 남아있었음)
    // 실제로는 단 한 번도 발송된 적이 없었던 것으로 보임. 마이탭 진입 시(하루 1회는 CF
    // 내부에서 자체적으로 중복 방지) 호출하도록 연결.
    notifyExpiringPoints(user.uid).catch(() => {});
    notifyUnreviewedReservations(user.uid).catch(() => {});
    const soon = new Date();
    soon.setDate(soon.getDate() + 30);
    const soonStr = soon.toISOString();
    const now = new Date().toISOString();
    getDocs(query(collection(db, 'pointHistory'),
      where('uid', '==', user.uid),
      where('expired', '==', false),
      where('type', '==', 'earn'),
    )).then(guard(snap => {
      let total = 0;
      snap.docs.forEach(d => {
        const data = d.data();
        if (data.expiresAt && data.expiresAt > now && data.expiresAt <= soonStr) {
          total += data.amount || 0;
        }
      });
      setExpiringPoints(total);
    })).catch(() => {});
  }, [isLoggedIn, user?.uid, isStoreAdmin]);

  useFocusEffect(React.useCallback(() => {
    activeRef.current = true;
    loadAlerts();
    return () => { activeRef.current = false; };
  }, [loadAlerts]));

  if (!isLoggedIn) {
    return (
      <View style={s.container}>
        <AppHeader rightElement={null} />
        <View style={s.center}>
          <Text style={{ fontSize:52, marginBottom:16 }}>🔑</Text>
          <Text style={s.guestTitle}>로그인이 필요합니다</Text>
          <Text style={s.guestSub}>로그인 후 예약, UNLOCK 기록,{'\n'}즐겨찾기 등을 이용하세요.</Text>
          <TouchableOpacity style={s.primaryBtn} onPress={() => navigation.navigate('Login')}>
            <Text style={s.primaryBtnTxt}>로그인 / 회원가입</Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  }

  const displayPoint  = isSuperAdmin ? '∞' : isStoreAdmin ? '0' : (profile?.points||0).toLocaleString();
  const statsPrivate  = profile?.statsPrivate  === true;
  const infoPrivate   = profile?.infoPrivate   === true;
  // 78차 69차: users.escapeStats(아무도 안 써주는 죽은 필드) 대신 라이브 계산값 사용
  const total         = liveEscapeStats?.total   || 0;
  const success       = liveEscapeStats?.success || 0;
  const showCount     = liveEscapeStats?.showCount || 0; // 80차 후속: 체험형 관람 횟수
  const level         = getLevel(total);
  const successRate   = total > 0 ? Math.round((success / total) * 100) : null;
  const photoURL      = profile?.photoURL || user?.photoURL || null;

  const handleToggleInfoPrivate = async () => {
    try {
      setLockLoading(true);
      const next = !infoPrivate;
      await updateDoc(doc(db, 'users', user.uid), { infoPrivate: next });
      await refreshProfile();
    } catch (e) { showAlert('오류', e.message); }
    finally { setLockLoading(false); }
  };

  const handlePickPhoto = async () => {
    try {
      const { status } = await ImagePicker.requestMediaLibraryPermissionsAsync();
      if (status !== 'granted') {
        showAlert('권한 필요', '사진 접근 권한이 필요합니다. 설정에서 허용해주세요.');
        return;
      }
      const result = await ImagePicker.launchImageLibraryAsync({
        mediaTypes: ImagePicker.MediaTypeOptions.Images,
        allowsEditing: true,
        aspect: [1, 1],
        quality: 0.7,
      });
      if (result.canceled) return;
      setPhotoLoading(true);
      const uri = result.assets[0].uri;
      const response = await fetch(uri);
      const blob = await response.blob();
      const storageRef = ref(storage, `profiles/${user.uid}/avatar.jpg`);
      await uploadBytes(storageRef, blob, { contentType:'image/jpeg' });
      const downloadURL = await getDownloadURL(storageRef);
      await updateDoc(doc(db, 'users', user.uid), { photoURL: downloadURL });
      await refreshProfile();
    } catch (e) {
      showAlert('오류', '사진 변경에 실패했습니다: ' + e.message);
    } finally { setPhotoLoading(false); }
  };

  // 78차 38차: 회원 탈퇴 기능 자체는 EditProfileScreen(프로필 수정)에 이미 있었으나
  // 마이 탭에서 눈에 안 띈다는 신고 — 로그아웃 버튼 옆에도 바로 접근 가능한 링크 추가
  // (탈퇴 로직 자체는 EditProfileScreen.js의 handleDeleteAccount와 동일).
  const handleDeleteAccount = () => {
    showAlert(
      '회원 탈퇴',
      '탈퇴하면 보유 포인트가 모두 소멸되고 되돌릴 수 없어요.\n(작성한 리뷰·모집글은 유지되나 작성자 정보는 "탈퇴한 회원"으로 표시됩니다.)\n정말 탈퇴하시겠어요?',
      [
        { text:'취소', style:'cancel' },
        { text:'탈퇴', style:'destructive', onPress: async () => {
          try {
            setDeleting(true);
            await deleteAccount();
          } catch (e) {
            showAlert('탈퇴 실패', e.message || '탈퇴 처리에 실패했어요.');
          } finally {
            setDeleting(false);
          }
        } },
      ],
    );
  };

  return (
    <View style={s.container}>
      <AppHeader rightElement={<RoleBadge role={adminRole} />} />

      <ScrollView style={s.body} showsVerticalScrollIndicator={false}>

        {/* ── 프로필 카드 ───────────────────────────────────── */}
        <View style={s.profileCard}>
          <View style={s.profileTop}>
            <TouchableOpacity style={s.avatarWrap} onPress={handlePickPhoto} disabled={photoLoading} accessibilityLabel="프로필 사진 변경">
              <LinearGradient colors={GRADIENTS.button} start={{x:0,y:0}} end={{x:1,y:1}} style={s.avatarRing}>
                {photoLoading ? (
                  <View style={s.avatar}><ActivityIndicator color={C.gold} /></View>
                ) : photoURL ? (
                  <Image source={{ uri: photoURL }} style={s.avatarImg} />
                ) : (
                  <View style={s.avatar}>
                    <Text style={s.avatarTxt}>
                      {(profile?.nickname || profile?.email || '?')[0].toUpperCase()}
                    </Text>
                  </View>
                )}
              </LinearGradient>
              <View style={s.cameraBadge}><CameraIcon size={11} color="#0a0a14" /></View>
            </TouchableOpacity>

            <View style={{ flex:1 }}>
              <View style={s.nameRow}>
                {!!profile?.crewName && (
                  <Text style={s.crewTag} numberOfLines={1}>[{profile.crewName}]</Text>
                )}
                <Text style={s.profileName} numberOfLines={1}>
                  {profile?.nickname || '닉네임 없음'}
                </Text>
                {!isAdmin && (
                  <View style={[s.levelBadge, { borderColor:level.color+'60', backgroundColor:level.color+'18' }]}>
                    <Text style={[s.levelTxt, { color:level.color }]}>{level.label}</Text>
                  </View>
                )}
              </View>
              <Text style={s.profileEmail}>{user?.email}</Text>
              {!isAdmin && (
                <TouchableOpacity
                  style={s.pointRow}
                  onPress={() => navigation.navigate('PointHistory')}
                  activeOpacity={0.7}>
                  <RewardIcon size={s.pointLabel.fontSize || 16} color={s.pointLabel.color} />
                  <Text style={s.pointVal}>{displayPoint} P</Text>
                  <Text style={[s.pointLabel, { color: C.gold + '80', fontSize: 11 }]}>내역 ›</Text>
                  {expiringPoints > 0 && (
                    <View style={s.expiringBadge}>
                      <Text style={s.expiringTxt}>
                        ⏳ {expiringPoints.toLocaleString()}P 30일 내 만료
                      </Text>
                    </View>
                  )}
                </TouchableOpacity>
              )}
            </View>

            {!isAdmin && (
              <TouchableOpacity
                style={[s.lockBtn, infoPrivate && s.lockBtnActive]}
                onPress={handleToggleInfoPrivate}
                disabled={lockLoading}
                hitSlop={{ top:10, bottom:10, left:10, right:10 }}>
                {lockLoading
                  ? <ActivityIndicator size="small" color={infoPrivate ? C.gold : C.muted} />
                  // 오늘 fork 재검토(이모지→아이콘 전수)로 확인: 잠김(PrivacyLockIcon)은
                  // 있지만 열림 상태 아이콘이 세트에 없어 토글 두 상태를 전부 아이콘으로
                  // 못 바꿈 — 신규 아이콘 필요, 이번 범위 밖이라 이모지 그대로 유지.
                  : <Text style={{ fontSize:18 }}>{infoPrivate ? '🔒' : '🔓'}</Text>}
              </TouchableOpacity>
            )}
          </View>

          {!isAdmin && !infoPrivate && (
            <>
              {profile?.bio ? (
                <View style={s.bioRow}>
                  <Text style={s.bioTxt} numberOfLines={2}>{profile.bio}</Text>
                </View>
              ) : (
                <TouchableOpacity
                  style={s.bioEmptyRow}
                  onPress={() => navigation.navigate('EditProfile', { section:'personal' })}>
                  <IconLabel Icon={EditIcon} size={12} color={C.muted} textStyle={s.bioEmptyTxt}>한줄 소개를 추가해보세요</IconLabel>
                </TouchableOpacity>
              )}

              {total === 0 && showCount === 0 ? (
                <View style={s.statEmptyRow}>
                  <Text style={s.statEmptyTxt}>🎯 아직 탈출 기록이 없어요</Text>
                </View>
              ) : (
                <>
                  {total > 0 && (
                    <View style={s.statCards}>
                      <View style={s.statCard}>
                        <Text style={[s.statVal, { color:C.text }]}>{total}</Text>
                        <Text style={s.statLbl}>도전</Text>
                      </View>
                      <View style={s.statCard}>
                        <Text style={[s.statVal, { color:C.gold }]}>{success}</Text>
                        <Text style={s.statLbl}>성공</Text>
                      </View>
                      {successRate !== null && (
                        <View style={s.statCard}>
                          <Text style={[s.statVal, { color:C.text }]}>{successRate}%</Text>
                          <Text style={s.statLbl}>성공률</Text>
                        </View>
                      )}
                    </View>
                  )}
                  {/* 80차 후속: 체험형 관람 횟수 — 방탈출 3-스탯과 분리해서 항상 노출 */}
                  {showCount > 0 && (
                    <View style={[s.statCards, { marginTop: total > 0 ? 8 : 0 }]}>
                      <View style={s.statCard}>
                        <Text style={[s.statVal, { color:COLORS.blue }]}>{showCount}</Text>
                        <Text style={s.statLbl}>체험형 관람</Text>
                      </View>
                    </View>
                  )}
                </>
              )}
            </>
          )}

          {!isAdmin && infoPrivate && (
            <View style={s.lockedNotice}>
              <IconLabel Icon={PrivacyLockIcon} size={12} color={C.muted} textStyle={s.lockedNoticeTxt} style={{ justifyContent:'center' }}>소개 · 탈출 기록이 숨겨져 있어요</IconLabel>
            </View>
          )}
        </View>

        {/* ── 결제 대기 예약 알림 배너 ───────────────────── */}
        {!isAdmin && pendingPayments.length > 0 && (
          <TouchableOpacity
            style={s.pendingPayBanner}
            onPress={() => navigation.navigate('ReservationHistory')}
            activeOpacity={0.8}>
            <View style={s.pendingPayLeft}>
              <WarningIcon size={s.pendingPayIcon.fontSize || 22} color={s.pendingPayIcon.color} />
              <View>
                <Text style={s.pendingPayTitle}>결제 미완료 예약이 있습니다</Text>
                <Text style={s.pendingPaySub}>
                  {pendingPayments.length}건의 예약이 결제 대기 중입니다
                </Text>
              </View>
            </View>
            <Text style={s.pendingPayArrow}>›</Text>
          </TouchableOpacity>
        )}

        {/* ── 모집 예약 현황 배너 ──────────────────────────── */}
        {!isAdmin && recruitReservations.length > 0 && (
          <TouchableOpacity
            style={s.recruitResBanner}
            onPress={() => navigation.navigate('ReservationHistory')}
            activeOpacity={0.8}>
            <View style={s.recruitResLeft}>
              <ParticipantAcceptIcon size={s.recruitResIcon.fontSize || 22} />
              <View>
                <Text style={s.recruitResTitle}>모집 예약 확정</Text>
                <Text style={s.recruitResSub}>
                  {recruitReservations.length}건의 파티 예약이 진행 중입니다
                </Text>
              </View>
            </View>
            <Text style={s.recruitResArrow}>›</Text>
          </TouchableOpacity>
        )}

        {/* ── 내 활동 ───────────────────────────────────── */}
        {!isAdmin && (
          <View style={s.menuSection}>
            <Text style={s.sectionLabel}>내 활동</Text>
            <View style={s.menuCard}>
              {[
                { Icon:MenuReservationIcon, label:'예약 내역',    sub:'예약 목록 · 결과 입력',    screen:'ReservationHistory' },
                { Icon:MenuEscapeIcon, label:'UNLOCK 기록',    sub:'성공률 · 통계 · 방문 기록', screen:'EscapeDashboard'    },
                { Icon:MenuReviewIcon, label:'내 리뷰',     sub:'작성한 리뷰 모아보기',           screen:'MyReviews'          },
                { Icon:MenuPointsIcon, label:'포인트 내역', sub:'적립 · 사용 · 소멸 예정 확인',  screen:'PointHistory'       },
              ].map((item, idx, arr) => (
                <TouchableOpacity key={item.screen}
                  style={[s.menuRow, idx < arr.length-1 && s.menuRowBorder]}
                  onPress={() => navigation.navigate(item.screen)} activeOpacity={0.7}>
                  <View style={s.menuIconWrap}><item.Icon size={18} /></View>
                  <View style={{ flex:1 }}>
                    <Text style={s.menuLabel}>{item.label}</Text>
                    <Text style={s.menuSub}>{item.sub}</Text>
                  </View>
                  {/* 74차: 예약 리마인더/매장 휴업 알림 있을 때 예약 내역 뱃지 */}
                  {item.screen === 'ReservationHistory' && reservationAlerts > 0 && (
                    <View style={s.menuAlertBadge}>
                      <Text style={s.menuAlertTxt}>{reservationAlerts > 99 ? '99+' : reservationAlerts}</Text>
                    </View>
                  )}
                  {/* 74차: 리뷰 작성 리마인더 알림 있을 때 내 리뷰 뱃지 */}
                  {item.screen === 'MyReviews' && reviewAlerts > 0 && (
                    <View style={s.menuAlertBadge}>
                      <Text style={s.menuAlertTxt}>{reviewAlerts > 99 ? '99+' : reviewAlerts}</Text>
                    </View>
                  )}
                  {/* 소멸 예정 포인트 있을 때 포인트 내역 뱃지 */}
                  {item.screen === 'PointHistory' && expiringPoints > 0 && (
                    <View style={s.menuWarnBadge}>
                      <Text style={s.menuWarnTxt}>소멸 예정</Text>
                    </View>
                  )}
                  {/* 32차: 탈출 기록 비공개 상태 배지 */}
                  {item.screen === 'EscapeDashboard' && statsPrivate && (
                    <View style={s.menuPrivateBadge}>
                      <IconLabel Icon={PrivacyLockIcon} size={11} color={C.gold} textStyle={s.menuPrivateTxt}>비공개</IconLabel>
                    </View>
                  )}
                  <Text style={s.menuArrow}>›</Text>
                </TouchableOpacity>
              ))}
            </View>
          </View>
        )}

        {/* ── 관심 · 모집 ──────────────────────────────── */}
        {!isAdmin && (
          <View style={s.menuSection}>
            <Text style={s.sectionLabel}>관심 · 모집</Text>
            <View style={s.menuCard}>
              {[
                { Icon:MenuFavoriteIcon, label:'즐겨찾기',     sub:'저장한 테마 목록',       screen:'Favorites'      },
                { Icon:MenuBellIcon, label:'알림',          sub:'수락·거절·신청 알림',    screen:'Notifications'  },
                { Icon:MenuRecruitIcon, label:'내 모집 관리', sub:'참가 · 작성 모집 현황', screen:'WaitingList', params:{ showBack:true } },
                // 80차 계속: 친구 초대 리워드 — 초대코드(본인 uid) 공유 화면 진입점
                { Icon:PeopleIcon, label:'친구 초대', sub:'초대하면 200P · 가입 시 100P', screen:'InviteFriend' },
                { Icon:MenuInquiryIcon, label:'문의 내역',    sub:'앱/매장 문의 내역과 답변 확인', screen:'MyInquiries' },
                // 74차: 공지·소식 탭이 크루 탭으로 바뀌면서, 공지사항/앱소식은 마이 탭에서
                // 진입하는 일반 화면으로 이동 (PICK 탭은 예약 탭 기본 화면으로 옮겨서 숨김)
                // 75차: 라벨 "공지사항" → "공지·소식" — 이 메뉴로 들어가면 실제로는 공지사항/
                // 앱소식 2개 탭인데 라벨이 "공지사항" 하나만 가리키는 것처럼 보여서 혼란
                // (홈 화면엔 PICK까지 3개가 있어 왜 다른가 하는 질문으로 이어짐). PICK을 여기
                // 추가하진 않음 — PICK은 매장이 직접 등록하는 다른 성격의 콘텐츠라 의도적으로
                // 분리(74차), 라벨만 실제 내용과 맞춤.
                { Icon:MenuNoticeIcon, label:'공지·소식', sub:'서비스 공지 및 앱 소식', screen:'Events', params:{ hidePick:true, showBack:true } },
              ].map((item, idx, arr) => (
                <TouchableOpacity key={item.screen}
                  style={[s.menuRow, idx < arr.length-1 && s.menuRowBorder]}
                  onPress={() => navigation.navigate(item.screen, item.params)} activeOpacity={0.7}>
                  <View style={s.menuIconWrap}><item.Icon size={18} /></View>
                  <View style={{ flex:1 }}>
                    <Text style={s.menuLabel}>{item.label}</Text>
                    <Text style={s.menuSub}>{item.sub}</Text>
                  </View>
                  {item.screen === 'Notifications' && notifCount > 0 && (
                    <View style={s.menuAlertBadge}>
                      <Text style={s.menuAlertTxt}>{notifCount > 99 ? '99+' : notifCount}</Text>
                    </View>
                  )}
                  {item.screen === 'WaitingList' && waitingListAlerts > 0 && (
                    <View style={s.menuAlertBadge}>
                      <Text style={s.menuAlertTxt}>{waitingListAlerts}</Text>
                    </View>
                  )}
                  {/* 75차: 문의 답변 알림 뱃지 — 기존엔 문의에 답변이 달려도 알림/뱃지가 전혀 없었음 */}
                  {item.screen === 'MyInquiries' && myInquiryReplyAlerts > 0 && (
                    <View style={s.menuAlertBadge}>
                      <Text style={s.menuAlertTxt}>{myInquiryReplyAlerts > 99 ? '99+' : myInquiryReplyAlerts}</Text>
                    </View>
                  )}
                  <Text style={s.menuArrow}>›</Text>
                </TouchableOpacity>
              ))}
            </View>
          </View>
        )}

        {/* ── 72차: 매장 관리 (매장관리자 전용) ───────────────
            기존엔 계정설정(닉네임·비밀번호·개인정보)만 보여서 마이탭이 거의 비어있었고,
            새 예약/리뷰 알림(notifBadge)이 쌓여도 열어볼 메뉴가 없었음(!isAdmin 섹션에만
            "알림" 링크가 있었음) — 매장관리자용 섹션을 별도로 추가해 둘 다 해결. */}
        {isStoreAdmin && (
          <View style={s.menuSection}>
            <Text style={s.sectionLabel}>매장 관리</Text>
            <View style={s.menuCard}>
              {[
                { Icon:MenuStoreIcon, label:'매장 정보',  sub:'매장명 · 플랜 · 연락처 확인/수정', screen:'StoreInfo' },
                // 신규: 자주 묻는 질문 모음 — 본사 문의 전에 스스로 확인할 수 있게 해서
                // 반복되는 단순 문의(휴업 방법, 테마 추가 방법 등)를 줄이는 목적.
                { Icon:HelpCircleIcon, label:'운영 Q&A', sub:'휴업·테마 추가 등 자주 묻는 질문', screen:'StoreAdminFaq' },
                // 75차: "문의사항" → "문의사항(사용자)"로 명확화 + "문의사항(매장)" 신규 —
                // 기존엔 매장관리자가 총괄관리자에게 문의(정산 이의제기 등)를 넣을 방법이
                // 마이탭에 아예 없었음(일반회원 전용 "문의 내역" 메뉴가 !isAdmin에만 있었음).
                // MyInquiries 화면 자체는 이미 있는 걸 그대로 재사용(getMyInquiries가
                // uid 기준이라 역할 무관하게 동작), "+작성"도 이미 그 화면에 있음.
                // 78차 36차: "(사용자)"/"(매장)" 접미사만으로는 방향(누가 누구에게)이 안
                // 와닿아 실기기 테스트에서 "차이를 모르겠다"는 신고 — 부제(sub)까지 안 읽어도
                // 라벨만 보고 바로 구분되도록 실제 동작 기준으로 이름 변경.
                { Icon:MenuInquiryIcon, label:'고객 문의 답변',  sub:'고객이 남긴 매장 문의에 답변',   screen:'Inquiries', params:{ mode:'store' } },
                { Icon:MenuInquiryIcon, label:'본사에 문의하기', sub:'정산 등 총괄관리자에게 문의하기', screen:'MyInquiries' },
                { Icon:MenuBellIcon, label:'알림',            sub:'새 예약 · 새 리뷰 등 운영 알림', screen:'Notifications' },
              ].map((item, idx, arr) => (
                <TouchableOpacity key={item.screen}
                  style={[s.menuRow, idx < arr.length-1 && s.menuRowBorder]}
                  onPress={() => navigation.navigate(item.screen, item.params)} activeOpacity={0.7}>
                  <View style={s.menuIconWrap}><item.Icon size={18} /></View>
                  <View style={{ flex:1 }}>
                    <Text style={s.menuLabel}>{item.label}</Text>
                    <Text style={s.menuSub}>{item.sub}</Text>
                  </View>
                  {item.screen === 'Notifications' && notifCount > 0 && (
                    <View style={s.menuAlertBadge}>
                      <Text style={s.menuAlertTxt}>{notifCount > 99 ? '99+' : notifCount}</Text>
                    </View>
                  )}
                  {/* 78차 66차: "고객 문의 답변" 미확인 뱃지 신규 — 기존엔 이 메뉴에 뱃지가
                      전혀 없었고, myInquiryReplyAlerts(본사 문의 답변)만 옆 메뉴에 붙어있어
                      "고객 문의 답변에 뱃지가 안 뜬다"는 신고의 원인이었음 */}
                  {item.screen === 'Inquiries' && item.params?.mode === 'store' && storeInquiryAlerts > 0 && (
                    <View style={s.menuAlertBadge}>
                      <Text style={s.menuAlertTxt}>{storeInquiryAlerts > 99 ? '99+' : storeInquiryAlerts}</Text>
                    </View>
                  )}
                  {item.screen === 'MyInquiries' && myInquiryReplyAlerts > 0 && (
                    <View style={s.menuAlertBadge}>
                      <Text style={s.menuAlertTxt}>{myInquiryReplyAlerts > 99 ? '99+' : myInquiryReplyAlerts}</Text>
                    </View>
                  )}
                  <Text style={s.menuArrow}>›</Text>
                </TouchableOpacity>
              ))}
            </View>
          </View>
        )}

        {/* ── 72차: 앱 관리 (총괄 관리자 전용) — 앱 자체 문의(targetType:'app') 응대 ── */}
        {isSuperAdmin && (
          <View style={s.menuSection}>
            <Text style={s.sectionLabel}>앱 관리</Text>
            <View style={s.menuCard}>
              <TouchableOpacity style={s.menuRow}
                onPress={() => navigation.navigate('Inquiries', { mode:'app' })} activeOpacity={0.7}>
                <View style={s.menuIconWrap}><MenuInquiryIcon size={18} /></View>
                <View style={{ flex:1 }}>
                  <Text style={s.menuLabel}>앱 문의</Text>
                  <Text style={s.menuSub}>특정 매장이 아닌 앱 전체 문의에 답변</Text>
                </View>
                {/* 75차: 미확인 문의 알림 배지 */}
                {inquiryAlerts > 0 && (
                  <View style={s.menuAlertBadge}>
                    <Text style={s.menuAlertTxt}>{inquiryAlerts > 99 ? '99+' : inquiryAlerts}</Text>
                  </View>
                )}
                <Text style={s.menuArrow}>›</Text>
              </TouchableOpacity>
            </View>
          </View>
        )}

        {/* ── 계정 설정 ─────────────────────────────────── */}
        <View style={s.menuSection}>
          <Text style={s.sectionLabel}>계정 설정</Text>
          <View style={s.menuCard}>
            {[
              { Icon:MenuNicknameIcon, label:'닉네임 변경',   sub:'2~12자, 금칙어 제외',                    screen:'EditProfile', params:{ section:'nickname' } },
              // 79차: [버그 수정] SNS 로그인 계정(카카오/네이버/구글/애플)은 이메일/비밀번호
              // 자격증명 자체가 없어서 이 메뉴로 들어가 뭘 입력해도 재인증이 항상 실패하는데
              // (원인을 알 수 없는 에러 메시지만 보임), provider 분기가 처음부터 없어 이
              // 메뉴 자체가 노출되고 있었음(전수 정독으로 발견) — 이메일 계정에만 노출.
              ...(profile?.provider === 'email' ? [
                { Icon:MenuPasswordIcon, label:'비밀번호 변경',  sub:'현재 비밀번호 확인 후 변경',              screen:'EditProfile', params:{ section:'password' } },
              ] : []),
              { Icon:MenuPrivacyIcon, label:'개인정보 변경',  sub:'한줄소개 · 성별 · 생년월일 · 정보 공개', screen:'EditProfile', params:{ section:'personal' } },
            ].map((item, idx, arr) => (
              <TouchableOpacity key={item.label}
                style={[s.menuRow, idx < arr.length-1 && s.menuRowBorder]}
                onPress={() => navigation.navigate(item.screen, item.params)} activeOpacity={0.7}>
                <View style={s.menuIconWrap}><item.Icon size={18} /></View>
                <View style={{ flex:1 }}>
                  <Text style={s.menuLabel}>{item.label}</Text>
                  <Text style={s.menuSub}>{item.sub}</Text>
                </View>
                <Text style={s.menuArrow}>›</Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>

        {/* ── 로그아웃 / 회원 탈퇴 ──────────────────────────── */}
        <View style={{ paddingHorizontal:16, paddingBottom:48 }}>
          <SecondaryButton label="로그아웃" onPress={() => {
            showAlert('로그아웃', '로그아웃 하시겠습니까?', [
              { text:'취소', style:'cancel' },
              { text:'로그아웃', style:'destructive',
                // 78차: signOut(auth) 직접 호출 대신 authService.logout() 경유 —
                // 로그아웃 직후 Firestore 네트워크 재구성까지 포함된 공용 로직(아래 참고)
                onPress:() => logout().catch(e => showAlert('오류', e.message)) },
            ]);
          }} />
          <TextButton
            label={deleting ? '처리 중...' : '회원 탈퇴'}
            onPress={handleDeleteAccount}
            disabled={deleting}
            style={{ alignSelf:'center', marginTop:12 }}
            textStyle={{ color:C.muted, fontSize:12 }}
          />
        </View>

      </ScrollView>
    </View>
  );
}

const s = StyleSheet.create({
  container:  { flex:1, backgroundColor:C.bg },
  center:     { flex:1, justifyContent:'center', alignItems:'center', padding:32 },
  body:       { flex:1 },
  guestTitle: { color:C.text, fontSize:18, fontWeight:'700', marginBottom:8 },
  guestSub:   { color:C.muted, fontSize:13, textAlign:'center', lineHeight:20, marginBottom:32 },

  profileCard:{
    margin:16, padding:18,
    backgroundColor:C.card,
    borderRadius:RADIUS.lg,
    borderWidth:1, borderColor:C.border,
    borderTopWidth:2, borderTopColor:C.gold,
    shadowColor:'#000', shadowOffset:{ width:0, height:3 },
    shadowOpacity:0.25, shadowRadius:8, elevation:4,
    gap:12,
  },
  profileTop:  { flexDirection:'row', alignItems:'center', gap:14 },

  avatarWrap:  { position:'relative', flexShrink:0 },
  avatarRing:  { width:72, height:72, borderRadius:36, padding:2,
                 alignItems:'center', justifyContent:'center' },
  avatar:      { width:'100%', height:'100%', borderRadius:34,
                 backgroundColor:C.card,
                 alignItems:'center', justifyContent:'center' },
  avatarImg:   { width:'100%', height:'100%', borderRadius:34 },
  avatarTxt:   { fontSize:26, fontWeight:'800', color:C.gold },
  cameraBadge: { position:'absolute', bottom:0, right:0,
                 width:22, height:22, borderRadius:11,
                 backgroundColor:C.gold, alignItems:'center', justifyContent:'center',
                 borderWidth:2, borderColor:C.card },

  nameRow:     { flexDirection:'row', alignItems:'center', gap:6, flexWrap:'wrap', marginBottom:2 },
  profileName: { fontSize:17, fontWeight:'800', color:C.text, flexShrink:1 },
  crewTag:     { fontSize:13, fontWeight:'700', color:C.gold },
  profileEmail:{ fontSize:12, color:C.muted, marginBottom:4 },
  levelBadge:  { borderRadius:6, borderWidth:1, paddingHorizontal:7, paddingVertical:2 },
  levelTxt:    { fontSize:10, fontWeight:'800' },
  pointRow:    { flexDirection:'row', alignItems:'center', gap:5, flexWrap:'wrap' },
  pointLabel:  { fontSize:13 },
  pointVal:    { fontSize:15, fontWeight:'800', color:C.gold },
  expiringBadge: { backgroundColor:C.warning+'26', borderRadius:6, borderWidth:1,
                   borderColor:C.warning+'66', paddingHorizontal:7, paddingVertical:2 },
  expiringTxt:   { color:C.warning, fontSize:10, fontWeight:'700' },

  lockBtn:      { width:38, height:38, borderRadius:10, borderWidth:1,
                  borderColor:C.border, backgroundColor:C.surface,
                  alignItems:'center', justifyContent:'center', flexShrink:0 },
  lockBtnActive:{ borderColor:C.gold+'60', backgroundColor:C.gold+'12' },

  bioRow:      { backgroundColor:C.surface, borderRadius:RADIUS.sm, borderWidth:1,
                 borderColor:C.border, paddingHorizontal:12, paddingVertical:10 },
  bioTxt:      { color:C.textSec, fontSize:14, lineHeight:20 },
  bioEmptyRow: { borderRadius:RADIUS.sm, borderWidth:1, borderColor:C.border,
                 borderStyle:'dashed', paddingHorizontal:12, paddingVertical:10, alignItems:'center' },
  bioEmptyTxt: { color:C.muted, fontSize:13 },

  statEmptyRow:{ backgroundColor:C.surface, borderRadius:RADIUS.sm, borderWidth:1,
                 borderColor:C.border, paddingHorizontal:12, paddingVertical:10 },
  statEmptyTxt:{ color:C.muted, fontSize:13 },
  statCards:   { flexDirection:'row', gap:8 },
  statCard:    { flex:1, backgroundColor:C.surface, borderRadius:14, borderWidth:1, borderColor:C.border,
                 paddingVertical:14, alignItems:'center' },
  statVal:     { fontSize:20, fontWeight:'700', marginBottom:3 },
  statLbl:     { color:C.muted, fontSize:11 },

  lockedNotice:   { backgroundColor:C.surface, borderRadius:RADIUS.sm, borderWidth:1,
                    borderColor:C.border, paddingHorizontal:12, paddingVertical:10 },
  lockedNoticeTxt:{ color:C.muted, fontSize:12, textAlign:'center' },

  menuSection:  { paddingHorizontal:16, marginBottom:16 },
  sectionLabel: { color:C.muted, fontSize:11, fontWeight:'700', letterSpacing:1.2,
                  textTransform:'uppercase', marginBottom:8, marginLeft:4 },
  menuCard:     { backgroundColor:C.card, borderRadius:RADIUS.md,
                  borderWidth:1, borderColor:C.border, overflow:'hidden' },
  menuRow:      { flexDirection:'row', alignItems:'center',
                  paddingHorizontal:16, paddingVertical:14, gap:12 },
  menuRowBorder:{ borderBottomWidth:1, borderBottomColor:C.border },
  menuIconWrap: { width:36, height:36, borderRadius:10, backgroundColor:C.goldBg,
                  alignItems:'center', justifyContent:'center' },
  menuIcon:     { fontSize:18 },
  menuLabel:    { color:C.text, fontSize:14, fontWeight:'700' },
  menuSub:      { color:C.muted, fontSize:11, marginTop:1 },
  menuArrow:    { color:C.muted, fontSize:22, fontWeight:'300' },

  menuAlertBadge: {
    backgroundColor:C.danger, borderRadius:10, minWidth:20, height:20,
    alignItems:'center', justifyContent:'center', paddingHorizontal:6, marginRight:6,
  },
  menuAlertTxt:   { color:'#fff', fontSize:11, fontWeight:'900' },
  menuWarnBadge:  {
    backgroundColor:C.warning+'26', borderRadius:8, borderWidth:1,
    borderColor:C.warning+'66', paddingHorizontal:8, paddingVertical:3, marginRight:6,
  },
  menuWarnTxt:    { color:C.warning, fontSize:11, fontWeight:'700' },
  // 32차: 통계 비공개 배지
  menuPrivateBadge: {
    backgroundColor:'rgba(212,168,67,0.10)', borderRadius:8, borderWidth:1,
    borderColor:'rgba(212,168,67,0.30)', paddingHorizontal:8, paddingVertical:3, marginRight:6,
  },
  menuPrivateTxt: { color:C.gold, fontSize:11, fontWeight:'700' },

  primaryBtn:    { backgroundColor:C.gold, borderRadius:RADIUS.md,
                   paddingVertical:12, paddingHorizontal:32, alignItems:'center' },
  primaryBtnTxt: { color:C.bg, fontWeight:'700', fontSize:14 },

  pendingPayBanner: {
    marginHorizontal:16, marginBottom:12,
    backgroundColor:C.warning+'1A',
    borderRadius:12, borderWidth:1, borderColor:C.warning+'59',
    flexDirection:'row', alignItems:'center',
    paddingHorizontal:14, paddingVertical:12,
  },
  pendingPayLeft:  { flex:1, flexDirection:'row', alignItems:'center', gap:10 },
  pendingPayIcon:  { fontSize:20 },
  pendingPayTitle: { color:C.warning, fontSize:13, fontWeight:'800' },
  pendingPaySub:   { color:'rgba(255,255,255,0.45)', fontSize:11, marginTop:2 },
  pendingPayArrow: { color:C.warning, fontSize:22 },

  recruitResBanner: {
    marginHorizontal:16, marginBottom:16,
    backgroundColor:C.success+'14',
    borderRadius:12, borderWidth:1, borderColor:C.success+'4D',
    flexDirection:'row', alignItems:'center',
    paddingHorizontal:14, paddingVertical:12,
  },
  recruitResLeft:  { flex:1, flexDirection:'row', alignItems:'center', gap:10 },
  recruitResIcon:  { fontSize:20 },
  recruitResTitle: { color:C.success, fontSize:13, fontWeight:'800' },
  recruitResSub:   { color:'rgba(255,255,255,0.45)', fontSize:11, marginTop:2 },
  recruitResArrow: { color:C.success, fontSize:22 },
});